import React, {useEffect, useState} from "react";
import {Routes, Route, useLocation} from "react-router-dom";
import HomePage from "./pages/home";
import SearchPage from "./pages/searchPage";
import ComparisonPage from "./pages/comparisonPage";
import CategoryFlightsPage from "./pages/categoryFlightsPage";
import "./App.css";
import UnlockPopup from "./auth/unlockPopup";
import GroupPlanningPage from "./pages/groupPlanningFeature";
import AuthGate from "./auth/AuthGate";
import SessionPreferencesPage from "./pages/grouptrip/SessionPreferencesPage";
import SessionFriendsInvitePage from "./pages/grouptrip/SessionFriendInvitePage";
import SessionWaitingPage from "./pages/grouptrip/SessionWaitingPage";
import SessionCreatePage from "./pages/grouptrip/SessionCreatePage";
import GroupResultsPage from "./pages/grouptrip/GroupResultPage";
import ResultsUnveilPage from "./pages/grouptrip/UnveilResultScreen";
import {RestrictedAccess} from "./auth/RestrictedAccess";
import SessionJoinPage from "./pages/grouptrip/SessionJoinPage";
import SharedFlightPage from "./pages/SharedFlightPage";
import DiscoveryPage from "./pages/DiscoveryPage";
import SharedShortlistPage from "./pages/SharedShortlistPage";
import ShortlistNavigation from "./components/shortlist/ShortlistNavigation";

function App() {
    const {pathname} = useLocation();
    const isPublicShare = pathname.startsWith("/flights/shared/") || pathname.startsWith("/shortlists/");
    const [isUnlocked, setIsUnlocked] = useState(
        localStorage.getItem("unlockStatus") === "unlocked"
    );

    // Check periodically if unlocked (e.g. after popup sets localStorage)
    useEffect(() => {
        const interval = setInterval(() => {
            const unlocked = localStorage.getItem("unlockStatus") === "unlocked";
            if (unlocked !== isUnlocked) {
                setIsUnlocked(unlocked);
            }
        }, 500); // 0.5s polling

        return () => clearInterval(interval);
    }, [isUnlocked]);

    return (
        <div className="relative">
            <div>
                {!isUnlocked && !isPublicShare && <UnlockPopup/>}
                <div className={isUnlocked || isPublicShare ? "" : "blur-sm pointer-events-none select-none"}>
                    <ShortlistNavigation/>
                    <Routes>
                        <Route path="/shortlists/:shortlistId" element={<SharedShortlistPage/>}/>
                        <Route path="/flights/shared/:shareId" element={<SharedFlightPage/>}/>
                        <Route path="/" element={<HomePage/>}/>
                        <Route path="/search" element={<SearchPage/>}/>
                        <Route path="/surprise" element={<DiscoveryPage key="surprise" mode="surprise"/>}/>
                        <Route path="/weekends" element={<DiscoveryPage key="weekend" mode="weekend"/>}/>
                        <Route path="/compare" element={<ComparisonPage/>}/>
                        <Route path="/flights/category/:categoryId" element={<CategoryFlightsPage/>}/>
                        <Route path="/group-planning" element={<GroupPlanningPage/>}/>
                        <Route path="/planthatrip" element={<AuthGate/>}/>
                        <Route path="/sessions" element={<AuthGate/>} />
                        <Route path="/sessions/:sessionId" element={<RestrictedAccess page={SessionWaitingPage}/>} />
                        <Route path="/sessions/create" element={<RestrictedAccess page={SessionCreatePage}/>} />
                        <Route path="/sessions/:sessionId/invite" element={<RestrictedAccess page={SessionFriendsInvitePage}/>} />
                        <Route path="/sessions/:sessionId/join" element={<RestrictedAccess page={SessionJoinPage} />} />
                        <Route path="/sessions/:sessionId/preferences" element={<RestrictedAccess page={SessionPreferencesPage}/>} />
                        <Route path="/sessions/:sessionId/unveil" element={<RestrictedAccess page={ResultsUnveilPage}/>} />
                        <Route path="/sessions/:sessionId/results" element={<RestrictedAccess page={GroupResultsPage}/>} />
                    </Routes>
                </div>
            </div>
        </div>

    );
}

export default App;
